/**
 * Reagiert auf Größenänderungen und skaliert Elemente entsprechend.
 *
 * @class service_v3sResponsiveScaleService
 * @memberOf v3sWbtPlayerApp:page
 */
angular.module('v3sWbtPlayerApp').factory('v3sResponsiveScaleService', ['$timeout', '$window', 'v3sBrowserInfoService', function ($timeout, $window, v3sBrowserInfoService) {

    var scalableElements = [];
    var oldWidth = 0;
    var timerPromise;

    /**
     * Fügt das Element zur Liste der Elemente hinzu, für die skaliert wird.
     *
     * @param element das hinzuzufügende Angular-Element
     * @memberOf v3sWbtPlayerApp:page:page.service_v3sResponsiveScaleService
     */
    function add(element) {
        scalableElements.push(element);
        delayedResize();
    }

    function doResizeAllElements() {
        angular.forEach(scalableElements, doResizeElement)
    }

    function doResizeElement(el) {
        var i, element, height, width, scale, elParent;
        var doc = angular.element(document.querySelector('v3s-document'));
        var docWidth = doc.prop('offsetWidth');

        if (docWidth != oldWidth ) {
            //for (i = 0; i < scalableElements.length; i++) {
                element = el;

                width = element.attr('v3s-width');
                scale = docWidth / width;
                elParent = element.parent();

                if (width > docWidth && v3sBrowserInfoService.isResponsiveView()) {
                    element.css('transform', 'scale(' + scale + ')');
                    height = element.prop('offsetHeight');

                    if (!elParent.data('responsive-wrapper')) {
                        element.wrap('<div class="v3s-responsive-wrapper"></div>');
                        elParent = element.parent();
                        elParent.data('responsive-wrapper', 'true');
                    }

                    elParent.css('width', docWidth + 'px');
                    elParent.css('height', (height * scale) + 'px');

                } else {
                    if (elParent.data('responsive-wrapper')) {
                        element.detach();
                        elParent.after(element);
                        elParent.remove();
                    }
                    element.css('transform', 'none');

                }
            //}
        }
    }

    function delayedResize() {
        if (timerPromise) {
            $timeout.cancel(timerPromise);
        }
        timerPromise = $timeout(doResizeAllElements, 100);
    }

    angular.element($window).on('resize orientationchange', delayedResize);

    return {
        add: add,
        doResizeElement: doResizeElement
    }
}]);